export default {
    getMenuArrayParent(arr, id) {
        var temp = []
        var forFn = function (list, id) {
            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                if (item.id == id) {
                    temp.unshift(item)
                    forFn(arr, item.pid)
                    break
                } else {
                    if (item.children) {
                        forFn(item.children, id)
                    }
                }
            }
        }
        forFn(arr, id)
        return temp
    },
    getAuthority() {
        let operation = localStorage.getItem('operation')
        return JSON.parse(operation)
    },
    getSessionStorage(name) {
        let operation = sessionStorage.getItem(name)
        return operation
    },
    /**
     * 获取url 参数
     */
    get_query() {
        let query = {};
        let search = location.search
        if (search.length > 2) {
            search = search.split('?')[1].split('&')
            for (let i = 0; i < search.length; i++) {
                let arr = search[i].split('=');
                if (arr.length == 2) {
                    query[arr[0]] = arr[1]
                }
            }
        }
        return query
    },

    /**
     * 导出文件
     */
    exportFile(urls, name) {
        return new Promise((resolve,reject) => {
            const x = new window.XMLHttpRequest();
            x.open('GET', urls, true);
            x.responseType = 'blob';
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank'
                a.download = name;
                a.click();
                resolve()
            };
            x.onerror = () => {
                reject()
            };
            x.send();
        })

    },
    // 处理链接参数
    urlParamsToObject(str) {
        let url = new URL(str)
        const params = new URLSearchParams(url.search);
        const paramObj = {};
        for (let [key, value] of params) {
        paramObj[key] = decodeURIComponent(value);
        }
        return paramObj;
    }

}